<div class="page">
  @if (request$ | async; as result) {
    @if (result.isLoading) {
      <app-spinner></app-spinner>
    } @else if (result.isError || !result.data) {
      <p class="error" translate="COMMON.ERROR_LOADING_DATA"></p>
    } @else {
      @let request = result.data;
      @let days = daysKey(request) | translate: { count: request.extensionInDays };
      <section class="card">
        <header class="header">
          <span class="badge"><mat-icon>more_time</mat-icon></span>
          <h1 translate="CALLS.RETENTION_EXTENSION_REQUEST.REVIEW_TITLE"></h1>
        </header>

        <p class="description">
          {{ 'CALLS.RETENTION_EXTENSION_REQUEST.REVIEW_DESCRIPTION' | translate: { requestedByName: request.requestedByName, days: days } }}
        </p>

        <dl class="details">
          <div class="detail">
            <dt translate="CALLS.RETENTION_EXTENSION_REQUEST.MEETING"></dt>
            <dd>
              @if (request.callName === null) {
                <span class="muted" translate="CALLS.RETENTION_EXTENSION_REQUEST.HIDDEN_CALL_NAME"></span>
              } @else {
                <span class="mask-call-name">{{ request.callName }}</span>
              }
              <span class="secondary">{{ request.callDate | date: dateTimeFormat }}</span>
            </dd>
          </div>
          <div class="detail">
            <dt translate="CALLS.RETENTION_EXTENSION_REQUEST.REQUESTED_BY"></dt>
            <dd>
              {{ request.requestedByName }}
              <span class="secondary">{{ request.createdAt | date: dateTimeFormat }}</span>
            </dd>
          </div>
          <div class="detail">
            <dt translate="CALLS.RETENTION_EXTENSION_REQUEST.EXTENSION"></dt>
            <dd>{{ days }}</dd>
          </div>
          @if (request.currentSoftDeletionDate !== null) {
            <div class="detail">
              <dt translate="CALLS.RETENTION_EXTENSION_REQUEST.CURRENT_EXPIRY"></dt>
              <dd>{{ request.currentSoftDeletionDate | date: dateTimeFormat }}</dd>
            </div>
          }
          @if (request.resultingSoftDeletionDate !== null) {
            <div class="detail resulting">
              <dt translate="CALLS.RETENTION_EXTENSION_REQUEST.NEW_EXPIRY"></dt>
              <dd>{{ request.resultingSoftDeletionDate | date: dateTimeFormat }}</dd>
            </div>
          }
        </dl>
        <p class="local-time">{{ 'COMMON.ALL_TIMES_IN_TIME_ZONE' | translate: { timeZone: localTimeZone } }}</p>

        @if (request.status === 'PENDING') {
          @if (request.isCallSoftDeleted) {
            <p class="notice" translate="CALLS.RETENTION_EXTENSION_REQUEST.SOFT_DELETED"></p>
          }
          <div class="actions">
            <button mat-stroked-button type="button" [disabled]="isDeciding" (click)="decide(request, 'decline')">
              <mat-icon>close</mat-icon>
              <span translate="CALLS.RETENTION_EXTENSION_REQUEST.DECLINE"></span>
            </button>
            <button mat-flat-button color="primary" type="button" [disabled]="isDeciding || request.isCallSoftDeleted" (click)="decide(request, 'approve')">
              <mat-icon>check</mat-icon>
              <span translate="CALLS.RETENTION_EXTENSION_REQUEST.APPROVE"></span>
            </button>
          </div>
        } @else {
          <p class="outcome" [class.approved]="request.status === 'APPROVED'" [class.declined]="request.status === 'DECLINED'">
            <mat-icon>{{ request.status === 'APPROVED' ? 'check_circle' : 'cancel' }}</mat-icon>
            {{
              (request.status === 'APPROVED' ? 'CALLS.RETENTION_EXTENSION_REQUEST.APPROVED' : 'CALLS.RETENTION_EXTENSION_REQUEST.DECLINED')
                | translate: { name: request.decidedByName, date: request.decidedAt | date: dateTimeFormat }
            }}
          </p>
          <a mat-stroked-button class="meetings-link" routerLink="/app/admin/meetings" translate="CALLS.RETENTION_EXTENSION_REQUEST.OPEN_MEETINGS"></a>
        }
      </section>
    }
  }
</div>
